var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Support Network"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Family Support"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(_vm.data.family_support ? _vm.data.family_support : "N/A")
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Access Number"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.social_connections ? _vm.data.social_connections : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Community Services"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.community_resources
                ? _vm.data.community_resources
                : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _vm._m(0),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.professional_care_contacts
                ? _vm.data.professional_care_contacts
                : "N/A"
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "flex-1 text-16 font-medium minWContent" },
      [
        _vm._v("Professional Care Contacts "),
        _c("span", { staticClass: "text-gray-400" }, [
          _vm._v("(Current Physiotherapist, Physician)"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }